import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  sls: [],
  isLoadingSls: false,
  slsDetails: [],
  isLoadingSlsDetails: false,
  isLoading: false,
  error: null,
};

export const getSLS: any = createAsyncThunk(
  "content/getSLS",
  async (params) => {
    const res = await axios.get(`/slpapp/Supplier/getall`, {
      params: params,
    });
    const data = await res?.data;

    return data;
  }
);

export const getSLSById: any = createAsyncThunk(
  "content/getSLSById",
  async ({ id }: any) => {
    const res = await axios.get(`/slpapp/Supplier/supplierbyId`, {
      params: { supplierId: id },
    });
    const data = await res?.data?.data;
    return data;
  }
);

export const addSLS: any = createAsyncThunk(
  "content/addUser",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/Supplier`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await res.data;

    return data;
  }
);

export const editSLS: any = createAsyncThunk(
  "content/editSLS",
  async ({ payload, id }: any) => {
    const res = await axios.put(`/slpapp/Supplier`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { supplierId: id },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteSLS: any = createAsyncThunk(
  "content/deleteSLS",
  async ({ id }: any) => {
    const res = await axios.delete(`/slpapp/Supplier`, {
      params: { supplierId: id },
    });
    const data = await res.data;
    return data;
  }
);

export const slsSlice = createSlice({
  name: "sls",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSLS.pending, (state) => {
      state.isLoadingSls = true;
    });
    builder.addCase(getSLS.fulfilled, (state, action) => {
      state.isLoadingSls = false;
      state.sls = action.payload;
    });
    builder.addCase(getSLS.rejected, (state, action) => {
      state.isLoadingSls = false;
      state.error = action.error.message;
    });

    builder.addCase(getSLSById.pending, (state) => {
      state.isLoadingSlsDetails = true;
    });
    builder.addCase(getSLSById.fulfilled, (state, action) => {
      state.isLoadingSlsDetails = false;
      state.slsDetails = action.payload;
    });
    builder.addCase(getSLSById.rejected, (state, action) => {
      state.isLoadingSlsDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(addSLS.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addSLS.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addSLS.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editSLS.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editSLS.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editSLS.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteSLS.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteSLS.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteSLS.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export default slsSlice.reducer;
